import { MutationTree } from 'vuex'
import { CookieState, CookieCategoryItemKey, CookieCategoryStatus } from './types'

export const mutations: MutationTree<CookieState> = {
  SET_OPTOUT (state, payload: string) {
    state.optout = payload
  },
  SET_CATEGORY (state, payload) {
    state.categories = {
      ...state.categories,
      ...payload
    }
  },
  UPDATE_CATEGORY_VALUE (state, cookieCategoryStatus: CookieCategoryStatus[]) {
    for (const { key, value } of cookieCategoryStatus) {
      const categoryKey = key as CookieCategoryItemKey
      if (state.categories) {
        const category = state.categories[categoryKey]
        category.checked = value
      }
    }
  }
}
